import React from 'react';
import styled from 'styled-components';

import { getScoreColors } from 'modules/health/helpers/getScoreColors';

interface CardHeaderProps {
  title: string;
  targetPercent: number;
  averageScore: number;
}

export const CardHeader = ({
  title,
  targetPercent,
  averageScore,
}: CardHeaderProps) => {
  const [color, borderColor] = getScoreColors(averageScore);

  return (
    <Header>
      <TitleGroup>
        <Title>{title}</Title>
        <Subtitle>Target: {targetPercent}%</Subtitle>
      </TitleGroup>
      <ScoreBadge $color={color} $borderColor={borderColor}>
        {averageScore}
      </ScoreBadge>
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 37px;
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 16px;
  line-height: 14px;
`;

const Subtitle = styled.p`
  font-size: 14px;
  line-height: 12px;
`;

const ScoreBadge = styled.div<{ $color: string; $borderColor: string }>`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 2px solid ${({ $borderColor }) => $borderColor};
  box-shadow: 0 1px 5px 0 #0003;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color};
  font-size: 20px;
  line-height: 14px;
`;
